import { render, staticRenderFns } from "./tkgl.vue?vue&type=template&id=f0ce703a&scoped=true"
import script from "./tkgl.vue?vue&type=script&lang=js"
export * from "./tkgl.vue?vue&type=script&lang=js"
import style0 from "./tkgl.vue?vue&type=style&index=0&id=f0ce703a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ce703a",
  null
  
)

export default component.exports